import { useReducer } from "react";

import SearchContext from "./search-context";

const defaultSearchContext = {
  items: [],
  compareToCabinet: true,
};

const searchReducer = (state, action) => {
  // add ingredient to search bar
  if (action.type === "ADD") {
    const existingSearchItemIndex = state.items.findIndex(
      (item) => item.id === action.item.id
    );

    if (existingSearchItemIndex !== -1) {
      return { items: state.items };
    }

    const updatedItems = state.items.concat(action.item);

    return {
      items: updatedItems,
    };
  }

  // remove item from search
  if (action.type === "REMOVE") {
    const updatedItems = state.items.filter((item) => item.id !== action.id);

    return {
      items: updatedItems,
    };
  }

  if (action.type === "CLEAR") {
    const updatedItems = [];

    return {
      items: updatedItems,
    };
  }

  if(action.type === "COMPARE"){
    const newCompare = action.setting

    return {
      items: state.items,
      compareToCabinet: newCompare
    }
  }
};

const SearchProvider = (props) => {
  const [searchState, dispatchSearchAction] = useReducer(
    searchReducer,
    defaultSearchContext
  );

  const addItemToSearchHandler = (item) => {
    dispatchSearchAction({ type: "ADD", item: item });
  };

  const removeItemFromSearchHandler = (id) => {
    dispatchSearchAction({ type: "REMOVE", id: id });
  };

  const clearSearchHandler = () => {
    dispatchSearchAction({ type: "CLEAR" });
  };

  const setCompareToCabinetHandler = (setting) => {
    dispatchSearchAction({ type: "COMPARE", setting: setting  });
  };


  const searchContext = {
    items: searchState.items,
    compareToCabinet: searchState.compareToCabinet,
    addItem: addItemToSearchHandler,
    removeItem: removeItemFromSearchHandler,
    clearSearch: clearSearchHandler,
    setCompareToCabinet: setCompareToCabinetHandler,
  };

  return (
    <SearchContext.Provider value={searchContext}>
      {props.children}
    </SearchContext.Provider>
  );
};

export default SearchProvider;
